import { success, failure, request } from 'app/actions';
import * as actions from './unitsActions';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
